"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerSchemaProperties = exports.QuickBooksTriggerSchema = exports.QuickBooksTriggerEventEnum = exports.TriggerSchema = exports.TriggerOutcomeEnum = exports.TriggerEventEnum = exports.TriggerTypeEnum = void 0;
const zod_1 = require("zod");
const activity_log_schema_1 = require("./activity-log-schema");
const base_schema_1 = require("./base-schema");
const intuit_realm_1 = require("./intuit-realm");
const schema_properties_interface_1 = require("./schema-properties-interface");
// Global Trigger Types
exports.TriggerTypeEnum = zod_1.z.enum(["quickbooks"]);
// Base Trigger
exports.TriggerEventEnum = zod_1.z.enum(["manual"]);
exports.TriggerOutcomeEnum = zod_1.z.enum(["success", "failure"]);
exports.TriggerSchema = base_schema_1.BaseSchema.extend({
    id: zod_1.z.string(),
    type: exports.TriggerTypeEnum,
    lastRunAt: zod_1.z.date().optional(),
    lastRunBy: zod_1.z.string().optional(),
    lastRunByType: activity_log_schema_1.ActorTypeEnum.optional(),
    lastRunOutcome: exports.TriggerOutcomeEnum.optional(),
    resourceId: zod_1.z.string(),
    resourceType: activity_log_schema_1.ResourceTypeEnum,
    event: exports.TriggerEventEnum,
});
// QuickBooks Trigger
exports.QuickBooksTriggerEventEnum = zod_1.z.enum([
    ...exports.TriggerEventEnum.options,
    "invoice",
    "payment",
    "refund",
    "client",
]);
exports.QuickBooksTriggerSchema = exports.TriggerSchema.extend({
    event: exports.QuickBooksTriggerEventEnum,
    realmId: zod_1.z.string(),
    ledgerId: zod_1.z.string(),
    fieldMapOverrides: zod_1.z.record(intuit_realm_1.FieldMapSchema).optional(),
});
exports.TriggerSchemaProperties = {
    collectionName: "triggers",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=trigger-schema.js.map